<script lang="ts">
	import { attrs } from '#library/attrs.ts'
	import type { Blok, Vacancies } from '#library/components.schema.build.ts'

	interface Props {
		blok: Blok<Vacancies>
	}

	let { blok }: Props = $props()
</script>

<svelte:head>
	<script src="./vacancy-filler/vf-settings.bedales.js" defer></script>
	<script src="./vacancy-filler/vf-main.min.js" defer></script>
</svelte:head>

<section class="vacancies {blok.theme}" {...attrs(blok)}>
	<div class="contain">
		<div id="VF_vacancies"></div>
	</div>
</section>

<style lang="css">
	.vacancies {
		padding-block: var(--padding-top, var(--padding-default)) var(--padding-bottom, var(--padding-default));

		:global {
			#VF_vacancies * {
				font-family: var(--f-family);
				letter-spacing: var(--ls-default);
			}

			#applicantGatewayLink,
			.vacancies-nav__link.active,
			.ui.basic.primary.button,
			.ui.basic.primary.buttons .button,
			.ui.primary.button,
			.ui.primary.buttons .button {
				background-color: var(--c-badley) !important;
			}

			.ui.labeled.icon.button > .icon,
			.ui.labeled.icon.buttons > .button > .icon {
				display: none !important;
			}

			.ui.labeled.icon.button,
			.ui.labeled.icon.buttons .button {
				padding-left: 1.5em !important;
			}

			.VF-job-title {
				color: var(--c-badley) !important;
			}

			.job-card-sharing-buttons.job-card-sharing-buttons-toggle.ui.small.basic.icon.buttons.right.floated {
				display: none !important;
			}

			.job-card-description {
				position: static;
			}
		}
	}
</style>
